import React, {useState, useEffect, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import UsersSearch from "../dashboard/calender/UsersSearch";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";

const UserModal = ({show, scale, onHide}) => {
    const [userId, setUserId] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const modalRef = useRef(null);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            const payload = {
                ...scale,
                users_id: userId?.value || null,
                user: userId || null,
                time_begin: scale.time_begin.slice(0, 5),
                time_end: scale.time_end.slice(0, 5),
                total_hours: scale.total_hours.slice(0, 5),
            };

            let response = await ApiService.send("put", `${process.env.REACT_APP_URL_API}scale/update`, payload, true);

            if (response?.code === 200) {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Escala Padrão salva com sucesso!",
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                });
                onHide(payload);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter" && show) {
                e.preventDefault();
                handleSave();
            }
        };

        const modalEl = modalRef.current;
        if (modalEl) {
            modalEl.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            if (modalEl) {
                modalEl.removeEventListener("keydown", handleKeyDown);
            }
        };
    }, [userId, show]);

    return (
        <Modal show={show} onHide={onHide} centered={true}>
            <div ref={modalRef}>
                <Modal.Header closeButton>
                    <Modal.Title>Selecionar Usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UsersSearch
                        departmentId={scale?.department_id}
                        situation="accepted"
                        buttonAdd={false}
                        onUserSelect={(user) => {
                            setUserId(user);
                        }}
                        initialUser={scale?.user}
                    />
                </Modal.Body>

                <div className="modal-footer">
                    <button type="button" className="btn btn-sm btn-dark"  onClick={() =>onHide(false)}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button type="button" className="btn btn-sm btn-primary"
                            onClick={handleSave}
                            disabled={isSaving}
                    >
                        {isSaving ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-save"></i> Salvar
                            </>
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default UserModal;
